export class MonthYearItem {
  constructor(month: number, monthName: string, year: number) {
    this.month = month;
    this.monthName = monthName;
    this.year = year;
  }

  readonly month: number;
  readonly monthName: string;
  readonly year: number;

  toJSON() {
    return { month: this.month, year: this.year };
  }
}
